module.exports = "/loading_spinner-ed2c4fc16fcd23c5ad71cd8e802cd9a1.gif";